@if (!habilitaTercero) {
  <div class="row m-0 p-1">
    <div class="col-md-12  d-flex justify-content-end">
      <button color="primary" mat-raised-button type="button" (click)="abrirSeccionTerceros()" [disabled]="false">
        <i class="fas fa-plus"></i>&nbsp;Nuevo
      </button>
    </div>
    <div class="col-md-12 my-4 overflow-auto">
      <table mat-table multiTemplateDataRows [dataSource]="datosTerceros.data | slice:(paginatorInfo?.pageStart ? paginatorInfo?.pageStart - 1 : 0):paginatorInfo?.pageEnd"
        class="table d-xl-table d-md-table d-sm-table table-responsive my-2">
        <ng-container matColumnDef="Tipo">
          <th mat-header-cell class="px-2" *matHeaderCellDef>Tipo</th>
          <td mat-cell *matCellDef="let element" class="mx-1">{{ element?.desc_tipo_tercero}}</td>
        </ng-container>
        <ng-container matColumnDef="Tercero">
          <th mat-header-cell class="px-2" *matHeaderCellDef>Tercero</th>
          <td mat-cell *matCellDef="let element" class="mx-1">{{element?.nombre_completo}}</td>
        </ng-container>
        <ng-container matColumnDef="Estatus">
          <th mat-header-cell class="px-2" *matHeaderCellDef>Estatus</th>
          <td mat-cell *matCellDef="let element" class="mx-1">{{element?.desc_estatus_tercero}}</td>
        </ng-container>
        <ng-container matColumnDef="Compañia">
          <th mat-header-cell class="px-2" *matHeaderCellDef>Compañia</th>
          <td mat-cell *matCellDef="let element" class="mx-1">{{element?.desc_cia_aseg}}</td>
        </ng-container>
        <ng-container matColumnDef="Placas">
          <th mat-header-cell class="px-2" *matHeaderCellDef>Placas</th>
          <td mat-cell *matCellDef="let element" class="mx-1">{{element?.placas}}</td>
        </ng-container>
        <ng-container matColumnDef="Acciones">
          <th mat-header-cell class="px-2" *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let element" class="mx-1">
            <div class="row justify-content-center">
              <div class="col-md-auto">
                <button color="primary" mat-raised-button type="button"
                  (click)="abrirSeccionTerceros(element)" [disabled]="false">
                  <i class="fas fa-edit"></i>
                </button>
              </div>
              <div class="col-md-auto">
                <button color="warn" mat-raised-button type="button" (click)="validaEliminacion(element)"
                  [disabled]="false">
                  <i class="fas fa-trash"></i>
                </button>
              </div>
            </div>
          </td>
        </ng-container>
        <!-- Sin resultados -->
        <ng-container matColumnDef="noData">
          <td mat-footer-cell *matFooterCellDef colspan="6">
            <small>No se encontró ningún resultado</small>
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayColumns;" (click)="seleccionarTercero(row)"> </tr>
        <tr mat-footer-row *matFooterRowDef="['noData']"
          [ngClass]="(datosTerceros?.data?.length === 0) ? '':'ocultarPaginator'">
        </tr>
      </table>
      <app-pagina-datos-tabla (eventPaginator)="paginatorInfo = $event" (click)="$event.stopPropagation()"
        [style.visibility]="datosTerceros?.data?.length >= 6 ? 'visible' : 'hidden'"
        [showFisrtLastButton]="true" [registerPerPage]="5" [totalLength]="datosTerceros?.data?.length">
      </app-pagina-datos-tabla>
    </div>
  </div>
}

@if (habilitaTercero) {
  <app-alta-tipo-terceros #altaTerceros [tercero]="terceroConsulta" [modulo]="modulo"
    (eventoTercero)="procesaEventosTercero($event)">
  </app-alta-tipo-terceros>
  <div class="row m-0 p-1 justify-content-end">
    <div class="col-md-auto d-flex justify-content-end">
      <button color="accent" mat-raised-button type="button" (click)="regresaConsulta()" [disabled]="false">
        Regresar
      </button>
    </div>
    <div class="col-md-auto d-flex justify-content-end">
      <button color="primary" mat-raised-button type="button" (click)="refAltaTerceros.guardarActualizarTercero()"
        [disabled]="false">
        Guardar
      </button>
    </div>
  </div>
}